import React from "react";
export enum DIALOG_TYPE {
  template,
  bulk,
  status,
  okta,
  addDomain,
  addUser,
  addAdmin,
}

export interface DialogOptions {
  modalType: DIALOG_TYPE;
  title?: string;
  description?: string | React.ReactNode;
  action?: string;
  data?: any;
}

export enum BULK_UPLOAD_STATE {
  DEFAULT,
  UPLOADING,
  ERROR,
}
